module.exports = __webpack_public_path__ + "img/businessTitle.480a4dc2.svg";